import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { useMediaQuery } from 'react-responsive'
import IconButton from '@material-ui/core/IconButton'
import { Container } from '@material-ui/core'
import logo from '../assets/images/logoNovo.png'
import styled from 'styled-components'
import UserMenu from './gridCoursesList/UserMenu'
import NavMenu from './NavMenu'
import { useQuery } from '@apollo/react-hooks'
import { userQueries } from '../graphql/queries/'
import Messages from './Messages'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { Link as RouterLink } from 'react-router-dom'

const Logo = styled.img`
  max-height: 32px;
  @media(max-width: 1050px) {
    max-height: 24px;
  }
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start
`

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  menuButton: {
    '&:hover': {
      backgroundColor: '#ccc'
    }
  },
  pageTitle: {
    fontSize: '22px',
    margin: 0
  },
  title: {
    flexGrow: 0,
    fontWeight: 300,
    fontSize: '13px',
    color: '#8E8E95',
    marginRight: '5px'
  },
  progress: {
    fontSize: '16px',
    margin: 0
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar
  },
  coursesToolBar: {
    justifyContent: 'space-between'
  },
  examToolbar: {
    justifyContent: 'flex-start'
  },
  linkButton: {
    width: 'auto',
    padding: 8
  }
}))

const Navbar = ({ type, counter, remainingQuestions}) => {
  const classes = useStyles()
  const isDefaultBreakpoint = useMediaQuery({ minDeviceWidth: 1050 })
  const { data } = useQuery(userQueries.GET_USER)


  const navBarContent = (content) => {
    if(content === 'default') return (<>
      <Logo src={logo} />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Messages />
        {isDefaultBreakpoint ? (
          <>
            <Typography variant="body1" className={classes.title}>
              Bem-vindo,{' '}
            </Typography>
            <Typography variant="body1">{((data || {}).usuario || {}).nome}</Typography>
          </>
        ) : ('')}
        <NavMenu menuIcon="expand">
          <UserMenu userData={(data || {})}/>
        </NavMenu>
      </div>
    </>)

    if(content === 'examBar') return (<>
      <IconButton className={classes.menuButton} color="primary" aria-label="menu" aria-haspopup="true" component={RouterLink} to={!remainingQuestions ? `/` : `/atividades`} >
        <ChevronLeftIcon/>
      </IconButton>
      <TextBox>
        <Typography gutterBottom variant="h5" component="h2" className={classes.pageTitle}  color={'primary'}>
          Provas e simulados
        </Typography>
        {(counter && remainingQuestions) !== undefined ? <Typography gutterBottom variant="h5" component="h5" className={classes.progress} color={'primary'}>
          {`Respondidas: ${counter} / Restantes: ${remainingQuestions}`}
        </Typography> : ''}
      </TextBox>
    </>)

    if(content === 'certified') return (<>
      <IconButton className={classes.menuButton} color="primary" aria-label="menu" aria-haspopup="true" component={RouterLink} to={`/`} >
        <ChevronLeftIcon/>
      </IconButton>
      <TextBox>
        <Typography gutterBottom variant="h5" component="h2" className={classes.pageTitle} color={'primary'}>
          Certificados
        </Typography>   
       
      </TextBox>
    </>)

  }

  


  return (
    <div className={classes.root}>
      <div className={classes.toolbar} />
      <AppBar position="fixed" elevation className={classes.navbar}>
        <Container >
          <Toolbar className={type === 'examBar' || type === 'certified'  ? classes.examToolbar : classes.coursesToolBar} disableGutters> 
            {navBarContent(type)}
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  )
}

export default Navbar
